import { defineComponent as _defineComponent } from 'vue'
import {banksDictionary} from '@/commons/dictionaries/BanksDictionary';
import {BankSymbol} from '@/commons/dictionaries/BankSymbol';
import {computed} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BankLogo',
  props: {
    bankSymbol: null,
    size: { default: 44 },
    lazy: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { bankSymbol?: BankSymbol, size: number, lazy: boolean }



const defaultBankLogo: string = require('@/assets/productTypesImg/avatarHipoteka.svg');

const logo = computed<string>(() => {
  if (props.bankSymbol) {
    const bank = banksDictionary().find(x => x.type === props.bankSymbol);
    if (bank) {
      return bank.symbolRequire;
    }
  }
  return defaultBankLogo;
});

return { __sfc: true,props, defaultBankLogo, logo }
}

})